import React, { useEffect, useState } from "react";
import VisorPluginPlaceholder from "../../_visor/components/canvas/VisorPluginPlaceholder";
import QuizStatusLine from "../../_visor/components/canvas/QuizStatusLine";
import { contentI18n as i18n } from "../../common/content_language";
import {
  setRgbaAlpha,
  shuffle,
  letterFromNumber,
  isShowNumbersCondition,
  getButtonText,
  showVisorToast,
} from "../../common/common_tools";
/* eslint-disable react/prop-types */

function generateIndexesBase(N, shuffleEnabled) {
  let a = [];
  for (let i = 0; i < N; ++i) {
    a[i] = i;
  }
  return shuffleEnabled ? shuffle(a) : a;
}

export default function MultipleAnswerVisor(props) {
  const [indexes, setIndexes] = useState(
    generateIndexesBase(props.state.nBoxes, props.state.shuffle)
  );

  // Re-generate indexes when number of boxes or shuffle setting changes
  useEffect(() => {
    setIndexes(generateIndexesBase(props.state.nBoxes, props.state.shuffle));
  }, [props.state.nBoxes, props.state.shuffle]);

  let content = [];
  let currentAnswer = props.props.exercises.currentAnswer;
  let sortAnswers = [];
  if (Array.isArray(currentAnswer)) {
    sortAnswers = [...currentAnswer].sort();
  }

  let attempted = props.props.exercises && props.props.exercises.attempted;
  let score = props.props.exercises.score || 0;
  score = Math.round(score * 100) / 100;
  score =
    props.props.exercises.weight === 0
      ? i18n.t("MultipleAnswer.notCount")
      : score + "/" + props.props.exercises.weight;
  // Page-wide submit marks every exercise attempted; only show feedback for one
  // the learner actually answered (non-empty selection array).
  let answered = Array.isArray(currentAnswer) && currentAnswer.length > 0;
  let showFeedback = attempted && answered && props.state.showFeedback;
  // Compare as sets: sort BOTH sides the same way. correctAnswer may be stored in
  // selection/click order, so without sorting it a correct-but-reordered answer
  // would read as wrong here (this drives feedback + answer-reveal styling).
  let istrue =
    attempted &&
    JSON.stringify(
      Array.isArray(props.props.exercises.correctAnswer)
        ? [...props.props.exercises.correctAnswer].sort()
        : props.props.exercises.correctAnswer
    ) == JSON.stringify(sortAnswers);
  const isTryAgainMode =
    props.state.buttons === "tryAgain" ||
    props.state.buttons === i18n.t("MultipleChoice.tryAgain") ||
    props.state.buttons === "Try Again" ||
    props.state.buttons === "Tekrar Dene";
  const showAnswerStyles = attempted;
  let quizColor = props.state.buttonBackgroundColor || "rgba(234, 183, 0, 1)";
  let correctAnswers = "";

  let buttonStyles = {
    backgroundColor: props.state.buttonBackgroundColor || "#EAB700",
    color: props.state.buttonTextColor || "#ffffff",
    borderColor: props.state.buttonBorderColor || "#EAB700",
    borderWidth: `${props.state.buttonBorderWidth || 1}px`,
    borderRadius: `${props.state.buttonBorderRadius || 4}px`,
    borderStyle: "solid",
    padding: `${props.state.buttonPadding || 8}px ${(props.state.buttonPadding || 8) * 1.5}px`,
    fontSize: `${props.state.buttonFontSize || 14}px`,
    fontWeight: props.state.buttonFontWeight || "normal",
    cursor: "pointer",
    margin: "2px",
    transition: "background-color 0.2s ease",
  };

  // if(istrue && this.props.props.pauseSound() != null) {
  //     this.props.props.pauseSound();
  // }

  let setAnswer = (i) => {
    let newCurrentAnswer = Array.isArray(sortAnswers) ? [...sortAnswers] : [];
    let index = newCurrentAnswer.indexOf(i);
    if (index === -1) {
      newCurrentAnswer.push(i);
    } else {
      newCurrentAnswer.splice(index, 1);
    }
    props.props.setAnswer(newCurrentAnswer);
  };
  function removeLastChar(s) {
    if (!s || s.length === 0) {
      return s;
    }

    return s.substring(0, s.length - 1);
  }
  let checked = [];
  let correctAnswer = [];
  for (let i = 0; i < props.state.nBoxes; i++) {
    checked = Array.isArray(sortAnswers) && sortAnswers.indexOf(indexes[i]) > -1;
    correctAnswer =
      props.props.exercises.correctAnswer &&
      Array.isArray(props.props.exercises.correctAnswer) &&
      props.props.exercises.correctAnswer.indexOf(indexes[i]) > -1;
    // Tekrar ("Try Again") modunda hiç kutu yanmaz (ne yeşil ne kırmızı) — cevap
    // açığa çıkmasın; sonuç yalnızca buton altındaki durum satırıyla bildirilir.
    // Diğer modlarda: tüm doğrular yeşil, işaretlenen yanlışlar kırmızı.
    let correct = showAnswerStyles && !isTryAgainMode && correctAnswer;
    let incorrect = showAnswerStyles && !isTryAgainMode && !correctAnswer && checked;

    content.push(
      <div
        key={indexes[i] + 1}
        className={
          "row answerRow " + (correct ? "correct " : " ") + (incorrect ? "incorrect " : " ")
        }
        style={
          attempted
            ? {
                opacity: checked || correct ? 1 : 0.25,
              }
            : undefined
        }
      >
        <div className={"col-xs-2 answerPlaceholder"}>
          <div
            className={"answer_letter"}
            style={{
              backgroundColor: quizColor,
              color: props.state.buttonTextColor,
              borderColor: props.state.buttonBorderColor,
              borderStyle: "solid",
              borderWidth: `${props.state.buttonBorderWidth ?? 1}px`,
              borderRadius: `${props.state.buttonBorderRadius ?? 4}px`,
              fontSize: `${props.state.buttonFontSize ?? 14}px`,
              fontWeight: props.state.buttonFontWeight || "normal",
              padding: `0 ${props.state.buttonPadding ?? 8}px`,
              width: "auto",
              minWidth: "1.75em",
            }}
          >
            {isShowNumbersCondition(props.state.letters) ? i + 1 : letterFromNumber(i)}
          </div>
          <input
            type="checkbox"
            disabled={attempted}
            className="checkQuiz"
            name={props.props.id}
            value={indexes[i]}
            checked={checked}
            aria-label={`${i18n.t("MultipleAnswer.Answer")} ${
              isShowNumbersCondition(props.state.letters) ? i + 1 : letterFromNumber(i)
            }`}
            onClick={(e) => {
              setAnswer(indexes[i]);
            }}
          />
        </div>
        <div
          className={"col-xs-10"}
          onClick={(e) => {
            setAnswer(indexes[i]);
          }}
        >
          <VisorPluginPlaceholder
            {...props.props}
            key={indexes[i]}
            pluginContainer={"Answer" + indexes[i]}
          />
        </div>
        {correct ? (
          <span className={"answerStatus correct"} aria-hidden="true">
            ✓
          </span>
        ) : incorrect ? (
          <span className={"answerStatus incorrect"} aria-hidden="true">
            ✕
          </span>
        ) : null}
      </div>
    );
    if (correctAnswer) {
      correctAnswers +=
        (isShowNumbersCondition(props.state.letters) ? i + 1 : letterFromNumber(i)) + ", ";
    }
  }
  if (!props.props.exercises.correctAnswer || props.props.exercises.correctAnswer.length === 0) {
    correctAnswers += i18n.t("MultipleAnswer.None") + ".";
  } else {
    correctAnswers = removeLastChar(removeLastChar(correctAnswers)) + ".";
  }

  let trueFeedbackContainer =
    props.props.boxes[props.props.id].sortableContainers["sc-TrueFeedback"];
  let trueFeedbackToolbar = trueFeedbackContainer?.children?.[0]
    ? props.props.toolbars[trueFeedbackContainer.children[0]]
    : null;

  let falseFeedbackContainer =
    props.props.boxes[props.props.id].sortableContainers["sc-FalseFeedback"];
  let falseFeedbackToolbar = falseFeedbackContainer?.children?.[0]
    ? props.props.toolbars[falseFeedbackContainer.children[0]]
    : null;

  let fixImgSvgStructure = (text) => {
    if (!text || typeof text !== "string") return text;
    let decoded = text;
    try {
      if (text.includes("%3C") || text.includes("%3E")) {
        decoded = decodeURIComponent(text);
      }
    } catch (e) {}

    decoded = decoded.replace(/<img\s*([^>]*?)>([\s\S]*?)<\/img>/gi, (match, attrs, content) => {
      if (content && content.trim() && content.includes("<svg")) {
        let spanAttrs = attrs ? attrs.trim() : "";
        if (spanAttrs && spanAttrs.includes("style=")) {
          spanAttrs = spanAttrs.replace(
            /style\s*=\s*["']([^"']*)["']/i,
            (styleMatch, styleContent) => {
              let cleanStyle = styleContent.trim().replace(/;\s*$/, "");
              return `style="${cleanStyle};display:inline-block;"`;
            }
          );
        } else {
          spanAttrs = (spanAttrs ? spanAttrs + " " : "") + 'style="display:inline-block;"';
        }
        return `<span ${spanAttrs}>${content}</span>`;
      }
      return match;
    });
    decoded = decoded.replace(/<img\s*([^>]*?)>\s*<svg/gi, (match, attrs) => {
      let spanAttrs = attrs ? attrs.trim() : "";
      if (spanAttrs && spanAttrs.includes("style=")) {
        spanAttrs = spanAttrs.replace(
          /style\s*=\s*["']([^"']*)["']/i,
          (styleMatch, styleContent) => {
            let cleanStyle = styleContent.trim().replace(/;\s*$/, "");
            return `style="${cleanStyle};display:inline-block;"`;
          }
        );
      } else {
        spanAttrs = (spanAttrs ? spanAttrs + " " : "") + 'style="display:inline-block;"';
      }
      return `<span ${spanAttrs}><svg`;
    });
    decoded = decoded.replace(/<\/svg>[\s\n]*<\/img>/gi, "</svg></span>");
    if (text.includes("%3C") || text.includes("%3E")) {
      try {
        return encodeURIComponent(decoded);
      } catch (e) {
        return decoded;
      }
    }
    return decoded;
  };

  let trueFeedbackText = fixImgSvgStructure(trueFeedbackToolbar?.state?.__text || "");
  let isDefaultTrueFeedbackMsg = false;

  let defaultTrueFeedbackMsg = "<p>" + i18n.t("MultipleChoice.TrueFeedbackMsg") + "</p>";

  if (
    trueFeedbackText === defaultTrueFeedbackMsg ||
    trueFeedbackText === encodeURI(defaultTrueFeedbackMsg) ||
    trueFeedbackText === encodeURI(defaultTrueFeedbackMsg + "\n") ||
    trueFeedbackText.includes(i18n.t("MultipleChoice.TrueFeedbackMsg"))
  ) {
    isDefaultTrueFeedbackMsg = true;
  }

  let checkEmptyTrueFeedback =
    (!trueFeedbackContainer?.children ||
      trueFeedbackContainer.children.length === 0 ||
      trueFeedbackToolbar?.state?.__text === "<p>" + i18n.t("text_here") + "</p>" ||
      trueFeedbackToolbar?.state?.__text === encodeURI("<p>" + i18n.t("text_here") + "</p>") ||
      trueFeedbackToolbar?.state?.__text === encodeURI("<p>" + i18n.t("text_here") + "</p>\n")) &&
    !isDefaultTrueFeedbackMsg;

  let falseFeedbackText = fixImgSvgStructure(falseFeedbackToolbar?.state?.__text || "");
  let isDefaultFalseFeedbackMsg = false;

  let defaultFalseFeedbackMsg = "<p>" + i18n.t("MultipleChoice.FalseFeedbackMsg") + "</p>";

  if (
    falseFeedbackText === defaultFalseFeedbackMsg ||
    falseFeedbackText === encodeURI(defaultFalseFeedbackMsg) ||
    falseFeedbackText === encodeURI(defaultFalseFeedbackMsg + "\n") ||
    falseFeedbackText.includes(i18n.t("MultipleChoice.FalseFeedbackMsg"))
  ) {
    isDefaultFalseFeedbackMsg = true;
  }

  let checkEmptyFalseFeedback =
    (!falseFeedbackContainer?.children ||
      falseFeedbackContainer.children.length === 0 ||
      falseFeedbackToolbar?.state?.__text === "<p>" + i18n.t("text_here") + "</p>" ||
      falseFeedbackToolbar?.state?.__text === encodeURI("<p>" + i18n.t("text_here") + "</p>") ||
      falseFeedbackToolbar?.state?.__text === encodeURI("<p>" + i18n.t("text_here") + "</p>\n")) &&
    !isDefaultFalseFeedbackMsg;

  return (
    <div
      className={
        "exercisePlugin multipleAnswerPlugin" +
        (attempted ? " attempted " : " ") +
        (showFeedback ? " showFeedback" : "") +
        (isTryAgainMode ? " tryAgain" : "")
      }
      style={{ "--q-btn-hover-bg": props.state.buttonHoverBackgroundColor || "#e67700" }}
    >
      {/* <h1>Multiple Answer</h1>*/}
      <div className={"row"} key={0}>
        <div className={"col-xs-12"}>
          <VisorPluginPlaceholder {...props.props} key="0" pluginContainer={"Question"} />
        </div>
      </div>
      <div className="q-answer-list">{content}</div>
      <div className="q-feedback-slot">
        {istrue && !checkEmptyTrueFeedback ? (
          <div
            className={"row feedbackRow"}
            key={-2}
            style={{ display: showFeedback ? "block" : "none" }}
          >
            <div
              className={"col-xs-12 feedback"}
              role="status"
              aria-live="polite"
              style={{
                color: /* quizColor*/ "black",
                borderColor: "#318533",
                backgroundColor: setRgbaAlpha("rgba(39,208,124,0.20)", 0.15),
                display: "flex",
                alignItems: "center",
              }}
            >
              <VisorPluginPlaceholder {...props.props} key="0" pluginContainer={"TrueFeedback"} />
            </div>
          </div>
        ) : null}
        {!istrue && !checkEmptyFalseFeedback ? (
          <div
            className={"row feedbackRow"}
            key={-2}
            style={{ display: showFeedback ? "block" : "none" }}
          >
            <div
              className={"col-xs-12 feedback"}
              role="status"
              aria-live="polite"
              style={{
                color: /* quizColor */ "black",
                borderColor: "#a31111",
                backgroundColor: setRgbaAlpha("rgba(213,26,26,0.20)", 0.15),
                display: "flex",
                alignItems: "center",
              }}
            >
              <VisorPluginPlaceholder
                {...props.props}
                key="1232"
                pluginContainer={"FalseFeedback"}
              />
            </div>
          </div>
        ) : null}
        {isTryAgainMode && !props.state.showFeedback ? (
          <QuizStatusLine correct={istrue} visible={attempted && answered} />
        ) : null}
      </div>
      {istrue ? (
        <div className="correctAnswerFeedback" style={{ color: quizColor }}>
          <span className="correctAnswerLabel">
            {" "}
            {i18n.t("MultipleAnswer.correctAnswerFeedback")}:
          </span>{" "}
          {correctAnswers}
        </div>
      ) : null}
      <div key={-1} className={"exerciseScore"} style={{ color: quizColor }}>
        {score}
      </div>
      <div className={"row"} key={7}>
        <button
          onClick={(e) => {
            if (props.state.shuffle) {
              setIndexes(generateIndexesBase(props.state.nBoxes, props.state.shuffle));
            }
            props.props.tryAgainHandler();
          }}
          style={{
            display:
              istrue ||
              !props.props.exercises.attempted ||
              (props.state.buttons != "tryAgain" &&
                props.state.buttons != i18n.t("MultipleChoice.tryAgain") &&
                props.state.buttons != "Try Again" &&
                props.state.buttons != "Tekrar Dene")
                ? "none"
                : "inline-block",
            ...buttonStyles,
            height: "48px",
          }}
          className={"tryButton"}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor =
              props.state.buttonHoverBackgroundColor || "#e67700";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = props.state.buttonBackgroundColor || "#EAB700";
          }}
        >
          {getButtonText(props.state.tryAgainText, "MultipleChoice.tryAgain")}
        </button>
        <button
          onClick={(e) => {
            props.props.seeAnswerHandler();
          }}
          style={{
            display:
              istrue ||
              !props.props.exercises.attempted ||
              (props.state.buttons != i18n.t("MultipleChoice.seeAnswer") &&
                props.state.buttons != "seeAnswer")
                ? "none"
                : "inline-block",
            ...buttonStyles,
          }}
          className={"tryButton"}
          onMouseEnter={(e) =>
            (e.target.style.backgroundColor = props.state.buttonHoverBackgroundColor || "#e67700")
          }
          onMouseLeave={(e) =>
            (e.target.style.backgroundColor = props.state.buttonBackgroundColor || "#EAB700")
          }
        >
          {getButtonText(props.state.seeAnswerText, "MultipleChoice.seeAnswer")}
        </button>
        <button
          onClick={(e) => {
            Array.isArray(props.props.exercises.currentAnswer) &&
            props.props.exercises.currentAnswer.length
              ? props.props.submitPage(props.props.currentView, props.props.id)
              : showVisorToast(i18n.t("MultipleChoice.selectOption"));
          }}
          style={{
            display: props.props.exercises.attempted ? "none" : "inline-block",
            ...buttonStyles,
            height: "48px",
          }}
          className={"tryButton"}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor =
              props.state.buttonHoverBackgroundColor || "#e67700";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = props.state.buttonBackgroundColor || "#EAB700";
          }}
        >
          {getButtonText(props.state.checkAnswerText, "MultipleChoice.checkAnswer")}
        </button>
      </div>
      <style
        dangerouslySetInnerHTML={{
          __html: `
               .multipleAnswerPlugin .checkQuiz:checked:after {
                  color: rgb(49 161 72);
                }
              `,
        }}
      />
    </div>
  );
}
